import Card from '@mui/material/Card';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../interface/ApplicationState';
import { updateLocalUser } from '../../redux/actions/userActions';
import { alpha, ToggleButton, ToggleButtonGroup, Typography, useTheme } from '@mui/material';
import { BotExchange } from '../../interface/BotExchange';
import { BINANCE_COM_ENDPOINT, BINANCE_TESTNET_ENDPOINT, BINANCE_US_ENDPOINT, COINBASE_URL, KRAKEN_BASE_URL } from '../../const';


export const ExchangeSelection = () =>
{
  const dispatch = useDispatch();
  const user = useSelector((state: ApplicationState) => state.userStore.user)
  const theme = useTheme()

  const botExchange = useSelector((state: ApplicationState) => state.userStore.user.botExchange)

  const handleChoose = (exchange: BotExchange) => {

    if(exchange === BotExchange.coinbase) dispatch(updateLocalUser({ botExchange: exchange, binanceApiEndpoint: COINBASE_URL }))
    if(exchange === BotExchange.kraken) dispatch(updateLocalUser({ botExchange: exchange, binanceApiEndpoint: KRAKEN_BASE_URL }))
    if(exchange === BotExchange.binance) dispatch(updateLocalUser({ botExchange: exchange , binanceApiEndpoint: BINANCE_COM_ENDPOINT }))
    if(exchange === BotExchange.binanceUS) dispatch(updateLocalUser({ botExchange: exchange, binanceApiEndpoint: BINANCE_US_ENDPOINT }))
    if(exchange === BotExchange.binanceTestnet) dispatch(updateLocalUser({ botExchange: exchange, binanceApiEndpoint: BINANCE_TESTNET_ENDPOINT }))
    if(exchange === BotExchange.gateIo) dispatch(updateLocalUser({ botExchange: exchange }))
  }

  return(
    <Card sx={localStyles.card(theme)}>
      <Typography variant="body2" sx={localStyles.copy(theme)}>
        Select the exchange environment for execution. Changing this updates the connector settings shown below.
      </Typography>

      <ToggleButtonGroup value={botExchange} exclusive onChange={(e: any) => handleChoose(e.target.value)} sx={localStyles.group(theme)}>
        <ToggleButton value={BotExchange.binance}>Binance</ToggleButton>
        <ToggleButton value={BotExchange.binanceUS}>Binance.US</ToggleButton>
        <ToggleButton value={BotExchange.binanceTestnet}>Binance TestNet</ToggleButton>
        <ToggleButton value={BotExchange.gateIo}>Gate.io</ToggleButton>
        <ToggleButton value={BotExchange.kraken}>Kraken</ToggleButton>
        <ToggleButton value={BotExchange.coinbase}>Coinbase</ToggleButton>

      </ToggleButtonGroup>

  </Card>

  )
}

const localStyles = {
  card: (theme: any) => ({
    backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.03 : 0.74),
    borderRadius: "16px",
    border: `1px solid ${alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.08 : 0.55)}`,
    padding: 2.5,
    boxShadow: "none",
  }),
  copy: (theme: any) => ({
    mb: 2,
    color: alpha(theme.palette.text.primary, 0.68),
    maxWidth: 760,
  }),
  group: (theme: any) => ({
    gap: 1,
    flexWrap: "wrap",
    '& .MuiToggleButton-root': {
      borderRadius: "12px !important",
      border: `1px solid ${alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.08 : 0.55)}`,
      color: theme.palette.text.primary,
      px: 1.5,
      py: 0.9,
      textTransform: "none",
      fontWeight: 600,
      backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.03 : 0.52),
    },
    '& .Mui-selected': {
      backgroundColor: `${alpha(theme.palette.info.main, theme.palette.mode === "dark" ? 0.24 : 0.18)} !important`,
      borderColor: `${alpha(theme.palette.info.main, 0.55)} !important`,
    },
  }),
}
